import escapeRegExp from 'lodash/escapeRegExp';
import orderBy from 'lodash/orderBy';

const copyExcept = (obj = {}, exception) => {
  const keys = Object.keys(obj);
  if (keys.length === 0) return obj;
  const newObj = {};
  keys.forEach((k) => {
    if (k !== exception) {
      newObj[k] = obj[k];
    }
  });
  return newObj;
};

export const groupTablesByServiceAreas = (tables = []) => {
  if (tables.length === 0) return tables;
  const group = [];
  tables.forEach((t) => {
    const tableObject = {};
    const indexServiceArea = group.findIndex((g) => g.serviceAreaName === t.serviceArea.name);
    if (t?.serviceArea && indexServiceArea < 0) {
      tableObject.serviceAreaName = t.serviceArea.name;
      tableObject.serviceArea = { ...t.serviceArea };
      tableObject.sortPosition = t.serviceArea.sortPosition;
      tableObject.tables = [copyExcept(t, 'serviceArea')];
      group.push(tableObject);
    }
    if (indexServiceArea >= 0) {
      group[indexServiceArea].tables.push(copyExcept(t, 'serviceArea'));
    }
  });
  return sortByPosition(group);
};

export const sortByPosition = (group) => {
  const sortedGroup = group.map((serviceArea) => {
    return {
      ...serviceArea,
      tables: orderBy(serviceArea.tables, ['sortPosition']),
    };
  });

  return orderBy(sortedGroup, ['sortPosition']);
};

/**
 * Returns the table number following the highest numeric suffix among the
 * given tables whose name matches the `{prefix}{number}` pattern.
 * Gaps are not filled: numbering always continues after the maximum.
 *
 * NOTE: this mirrors the bulk-create numbering rule implemented in
 * parrot-api (`AreaTableSelector.get_next_table_number_by_prefix`);
 * keep both implementations in sync.
 */
export const getNextTableNumberByPrefix = (tables = [], prefix = '') => {
  const normalizedPrefix = (prefix || '').toUpperCase();
  const pattern = new RegExp(`^${escapeRegExp(normalizedPrefix)}(\\d+)$`);

  const maxSuffix = tables.reduce((max, table) => {
    const match = pattern.exec(table?.name || '');
    if (!match) return max;
    return Math.max(max, parseInt(match[1], 10));
  }, 0);

  return maxSuffix + 1;
};

/**
 * Builds the table names the bulk-create endpoint will generate for the
 * given existing tables, prefix and total of tables to create.
 */
export const buildBulkTableNames = (tables = [], prefix = '', totalTables = 0) => {
  const normalizedPrefix = (prefix || '').toUpperCase();
  const nextNumber = getNextTableNumberByPrefix(tables, normalizedPrefix);

  return Array.from(
    { length: totalTables },
    (_, idx) => `${normalizedPrefix}${String(nextNumber + idx).padStart(2, '0')}`,
  );
};

export const getDefaultAccordionState = (groups = []) => {
  const defaultState = {};
  groups.forEach((g) => {
    if (g?.serviceArea?.uuid) {
      defaultState[g.serviceArea.uuid] = true;
    }
  });
  return defaultState;
};
